var map = {
	"./clinic-def-marker.png": "3265",
	"./clinic-fr-marker.png": "ee7d",
	"./clinic-frbl-marker.png": "2a83",
	"./clinic-pfr-marker.png": "f62c",
	"./comm-def-marker.png": "8bd0",
	"./comm-fr-marker.png": "1b47",
	"./comm-frbl-marker.png": "e8a9",
	"./comm-pfr-marker.png": "140e",
	"./default-def-marker.png": "5769",
	"./default-fr-marker.png": "fe86",
	"./default-frbl-marker.png": "eaae",
	"./default-pfr-marker.png": "54e7",
	"./hosp-def-marker.png": "8c8d",
	"./hosp-fr-marker.png": "4dae",
	"./hosp-frbl-marker.png": "3149",
	"./hosp-pfr-marker.png": "7e16",
	"./ltc-def-marker.png": "628c",
	"./ltc-fr-marker.png": "686a",
	"./ltc-frbl-marker.png": "369b",
	"./ltc-pfr-marker.png": "39ac",
	"./mh-def-marker.png": "34e5",
	"./mh-fr-marker.png": "37f1",
	"./mh-frbl-marker.png": "f888",
	"./mh-pfr-marker.png": "442f",
	"./pc-def-marker.png": "41a9",
	"./pc-fr-marker.png": "48eb",
	"./pc-frbl-marker.png": "34fc",
	"./pc-pfr-marker.png": "2b67"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7708";